import React from 'react';
import FileStorage from '../components/FileStorage';

const PharmacologyToxicology = () => {
  return (
    <FileStorage
      category="pharmacology-toxicology"
      title="Pharmacology & Toxicology Data"
      description="Drug safety studies, efficacy data, and toxicology reports"
    />
  );
};

export default PharmacologyToxicology;